import { useGlobalContext } from '@honeycomb/data';
import Script from 'next/script';

export function ResponseTapTrack() {
    const {
        configSettings: { HCResponseTapInstallationId },
    } = useGlobalContext();
    return (
        <Script
            strategy="lazyOnload"
            id="infinity"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: `(function (n, t, i, r, u, f, e) { u = n._its = function () { return u.queue.push(arguments) }; u.version = "2.0"; u.queue = []; e = t.createElement(i); e.async = !0; e.src = r; f = t.getElementsByTagName(i)[0]; f.parentNode.insertBefore(e, f) })(window, document, "script", "https://script.infinity-tracking.com/infinitytrack.js?i=${HCResponseTapInstallationId}"); window._its("init", ${HCResponseTapInstallationId}); window._its("track");`,
            }}
        />
    );
}
